import { render, staticRenderFns } from "./campus-recruitment-card.vue?vue&type=template&id=488e0cc9&scoped=true"
import script from "./campus-recruitment-card.vue?vue&type=script&lang=js"
export * from "./campus-recruitment-card.vue?vue&type=script&lang=js"
import style0 from "./campus-recruitment-card.vue?vue&type=style&index=0&id=488e0cc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e0cc9",
  null
  
)

export default component.exports